import React, { useEffect, useState } from 'react';
import Slidebar from './Slidebar';
import apiInstance from '../../utils/axios';
import UserData from '../plugin/UserData';
import { useParams, Link } from 'react-router-dom';
import moment from 'moment';
import './style/customer-dashboard.css';
import PriceFormat_Basic from '../../components/commerce-ui/price-format-basic';

function OrderDetail() {
    const [order, setOrder] = useState({})
    const [orderItems, setOrderItems] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const userData = UserData()
    const param = useParams()

    useEffect(() => {
        if (userData?.user_id && param.order_oid) {
            setLoading(true);
            apiInstance.get(`customer/order/${userData.user_id}/${param.order_oid}/`)
                .then((res) => {
                    setOrder(res.data)
                    setOrderItems(res.data.orderitem || [])
                    setLoading(false)
                })
                .catch((error) => {
                    console.error('Error fetching order:', error);
                    setError("Error al cargar los detalles del pedido");
                    setLoading(false)
                });
        }
    }, [userData?.user_id, param.order_oid])

    if (loading) {
        return (
            <div className="customer-dashboard">
                <div className="container text-center py-5">
                    <div className="spinner-border loading-spinner" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <p className="mt-3">Cargando detalles del pedido...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="customer-dashboard">
                <div className="container text-center py-5">
                    <div className="alert alert-danger error-alert" role="alert">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {error}
                    </div>
                    <Link to="/customer/orders/" className="btn btn-primary mt-3">
                        <i className="fas fa-arrow-left me-2"></i> Volver a Pedidos
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="customer-dashboard">
            <main className="mt-4 mt-md-5">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-12 d-md-none">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className="mb-0">
                                    <i className="fas fa-shopping-cart text-primary" /> Order #{order.oid}
                                </h3>
                                <Link to="/customer/orders/" className="btn btn-outline-secondary btn-sm">
                                    <i className="fas fa-arrow-left me-2"></i> Volver
                                </Link>
                            </div>
                        </div>
                        
                        <Slidebar />

                        <div className="col-lg-9 col-md-12">
                            <div className="d-none d-md-flex justify-content-between align-items-center mb-4">
                                <h3 className="mb-0">
                                    <i className="fas fa-shopping-cart text-primary" /> Order #{order.oid}
                                </h3>
                                <div className="d-flex gap-2">
                                    <Link to="/customer/orders/" className="btn btn-outline-secondary btn-sm">
                                        <i className="fas fa-arrow-left me-2"></i> Volver a Pedidos
                                    </Link>
                                    <Link to={`/customer/invoice/${order.oid}/`} className="btn btn-outline-primary btn-sm">
                                        <i className="fas fa-file-invoice me-2"></i> Ver Factura
                                    </Link>
                                </div>
                            </div>

                            {/* Order Summary Cards */}
                            <div className="row g-3 mb-4">
                                <div className="col-12 col-sm-6 col-lg-3">
                                    <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                        <div className="card-body p-4 text-center">
                                            <div className="d-flex align-items-center justify-content-center mb-3" style={{ 
                                                width: "50px", 
                                                height: "50px", 
                                                backgroundColor: "#e3f2fd", 
                                                borderRadius: "12px" 
                                            }}>
                                                <i className="fas fa-dollar-sign text-primary fs-4"></i>
                                            </div>
                                            <p className="mb-1 text-muted small fw-medium">Monto Total</p>
                                            <h4 className="mb-0 text-dark fw-bold">${order.total || '0.00'}</h4>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-sm-6 col-lg-3">
                                    <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                        <div className="card-body p-4 text-center">
                                            <div className="d-flex align-items-center justify-content-center mb-3" style={{ 
                                                width: "50px", 
                                                height: "50px", 
                                                backgroundColor: "#fff8e1", 
                                                borderRadius: "12px" 
                                            }}>
                                                <i className="fas fa-credit-card text-warning fs-4"></i>
                                            </div>
                                            <p className="mb-1 text-muted small fw-medium">Estado del Pago</p>
                                            <span className={`badge rounded-pill px-3 py-2 ${
                                                order.payment_status === 'paid' ? 'bg-success' : 
                                                order.payment_status === 'pending' ? 'bg-warning' : 
                                                order.payment_status === 'processing' ? 'bg-info' : 'bg-secondary'
                                            }`}>
                                                {order.payment_status?.toUpperCase() || 'PENDING'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-sm-6 col-lg-3">
                                    <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                        <div className="card-body p-4 text-center">
                                            <div className="d-flex align-items-center justify-content-center mb-3" style={{ 
                                                width: "50px", 
                                                height: "50px", 
                                                backgroundColor: "#f1f8e9", 
                                                borderRadius: "12px" 
                                            }}>
                                                <i className="fas fa-truck text-success fs-4"></i>
                                            </div>
                                            <p className="mb-1 text-muted small fw-medium">Estado del Pedido</p>
                                            <span className={`badge rounded-pill px-3 py-2 ${
                                                order.order_status === 'fulfilled' ? 'bg-success' : 
                                                order.order_status === 'pending' ? 'bg-warning' : 
                                                order.order_status === 'cancelled' ? 'bg-danger' : 'bg-secondary'
                                            }`}>
                                                {order.order_status || 'PENDING'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-sm-6 col-lg-3">
                                    <div className="card stats-card border-0 shadow-sm h-100 depth-2">
                                        <div className="card-body p-4 text-center">
                                            <div className="d-flex align-items-center justify-content-center mb-3" style={{ 
                                                width: "50px", 
                                                height: "50px", 
                                                backgroundColor: "#fce4ec", 
                                                borderRadius: "12px" 
                                            }}>
                                                <i className="fas fa-calendar text-danger fs-4"></i>
                                            </div>
                                            <p className="mb-1 text-muted small fw-medium">Fecha del Pedido</p>
                                            <h6 className="mb-0 text-dark fw-semibold">
                                                {order.date ? moment(order.date).format('MMM DD, YYYY') : 'N/A'}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Order Details */}
                            <div className="row g-3 mb-4">
                                <div className="col-12 col-lg-6">
                                    <div className="card border-0 shadow-sm depth-2">
                                        <div className="card-header bg-white border-0 py-3">
                                            <h5 className="mb-0 text-dark fw-semibold">
                                                <i className="fas fa-user me-2 text-primary"></i>
                                                Información del Cliente
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <label className="form-label text-muted small">Nombre Completo</label>
                                                    <p className="mb-0 fw-semibold">{order.full_name || 'N/A'}</p>
                                                </div>
                                                <div className="col-12 col-sm-6">
                                                    <label className="form-label text-muted small">Correo Electrónico</label>
                                                    <p className="mb-0 fw-semibold">{order.email || 'N/A'}</p>
                                                </div>
                                                <div className="col-12 col-sm-6">
                                                    <label className="form-label text-muted small">Teléfono</label>
                                                    <p className="mb-0 fw-semibold">{order.phone || 'N/A'}</p>
                                                </div>
                                                <div className="col-12">
                                                    <label className="form-label text-muted small">Dirección</label>
                                                    <p className="mb-0 fw-semibold">
                                                        {order.address}, {order.city}, {order.state}, {order.country}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-12 col-lg-6">
                                    <div className="card border-0 shadow-sm depth-2">
                                        <div className="card-header bg-white border-0 py-3">
                                            <h5 className="mb-0 text-dark fw-semibold">
                                                <i className="fas fa-calculator me-2 text-primary"></i>
                                                Resumen del Pedido
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="text-muted">Subtotal:</span>
                                                <span className="fw-semibold">${order.sub_total || '0.00'}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="text-muted">Envío:</span>
                                                <span className="fw-semibold">${order.shipping_ammount || '0.00'}</span>
                                            </div>

                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="text-muted">Tarifa de Servicio:</span>
                                                <span className="fw-semibold">${order.service_fee || '0.00'}</span>
                                            </div>
                                            {order.saved && order.saved > 0 && (
                                                <div className="d-flex justify-content-between mb-2">
                                                    <span className="text-success">Descuento</span>
                                                    <span className="fw-semibold text-success">-${order.saved}</span>
                                                </div>
                                            )}
                                            <hr />
                                            <div className="d-flex justify-content-between">
                                                <span className="fw-bold fs-5">Total:</span>
                                                <span className="fw-bold fs-5 text-primary">${order.total || '0.00'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Order Items */}
                            <div className="card border-0 shadow-sm depth-2">
                                <div className="card-header bg-white border-0 py-3">
                                    <h5 className="mb-0 text-dark fw-semibold">
                                        <i className="fas fa-box me-2 text-primary"></i>
                                        Artículos del Pedido ({orderItems.length})
                                    </h5>
                                </div>
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th className="border-0 text-muted fw-semibold px-4 py-3">Producto</th>
                                                    <th className="border-0 text-muted fw-semibold px-4 py-3 d-none d-md-table-cell">Precio</th>
                                                    <th className="border-0 text-muted fw-semibold px-4 py-3">Cant.</th>
                                                    <th className="border-0 text-muted fw-semibold px-4 py-3">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orderItems.length > 0 ? (
                                                    orderItems.map((item, index) => (
                                                        <tr key={index} className="border-bottom fade-in">
                                                            <td className="px-4 py-3">
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        src={item.product?.image}
                                                                        style={{ 
                                                                            width: "60px", 
                                                                            height: "60px", 
                                                                            objectFit: "cover", 
                                                                            borderRadius: "8px" 
                                                                        }}
                                                                        alt={(item.product?.title_translated || item.product?.title)}
                                                                        className="me-3"
                                                                    />
                                                                    <div>
                                                                        <p className="fw-semibold mb-1 text-dark">{item.product?.title_translated || item.product?.title}</p>
                                                                        {item.color && (
                                                                            <small className="text-muted">Color: {item.color}</small>
                                                                        )}
                                                                        {item.size && (
                                                                            <small className="text-muted ms-2">Talla: {item.size}</small>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="px-4 py-3 d-none d-md-table-cell">
                                                                <PriceFormat_Basic value={item.price || 0} />
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <span className="badge bg-light text-dark px-3 py-2">{item.qty}</span>
                                                            </td>
                                                            <td className="px-4 py-3">
                                                                <PriceFormat_Basic value={item.sub_total || 0} className="fw-bold text-dark" />
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="4" className="text-center py-5">
                                                            <div className="empty-state">
                                                                <div className="empty-state-icon">
                                                                    <i className="fas fa-box-open fa-2x"></i>
                                                                </div>
                                                                <h6 className="mb-2 text-dark">No se encontraron artículos</h6>
                                                                <p className="text-muted mb-0">Este pedido no tiene artículos.</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Mobile Order Items Cards */}
                            <div className="d-md-none mt-4">
                                {orderItems.length > 0 && (
                                    <div className="row g-3">
                                        {orderItems.map((item, index) => (
                                            <div key={index} className="col-12">
                                                <div className="card mobile-order-card border-0 shadow-sm depth-1 slide-up">
                                                    <div className="card-body p-4">
                                                        <div className="d-flex align-items-start mb-3">
                                                            <img
                                                                src={item.product?.image}
                                                                style={{ 
                                                                    width: "60px", 
                                                                    height: "60px", 
                                                                    objectFit: "cover", 
                                                                    borderRadius: "8px" 
                                                                }}
                                                                alt={(item.product?.title_translated || item.product?.title)}
                                                                className="me-3"
                                                            />
                                                            <div className="flex-grow-1">
                                                                <h6 className="fw-semibold mb-1 text-dark">{item.product?.title_translated || item.product?.title}</h6>
                                                                <div className="d-flex gap-2 mb-2">
                                                                    {item.color && (
                                                                        <small className="text-muted">Color: {item.color}</small>
                                                                    )}
                                                                    {item.size && (
                                                                        <small className="text-muted">Size: {item.size}</small>
                                                                    )}
                                                                </div>
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <span className="text-muted">Cant.: {item.qty}</span>
                                                                    <span className="fw-bold text-primary">${item.sub_total || '0.00'}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default OrderDetail;